module.exports = __webpack_public_path__ + "static/media/1.11_preview.e3c88141.png";